import type { IProductSpecificationFieldReference } from 'src/types/reference/IProductSpecificationReference';

// No good check on cycle!!!
export function getDependentFieldsChain(
  parentField: IProductSpecificationFieldReference,
  allFields: IProductSpecificationFieldReference[]
): IProductSpecificationFieldReference[] {
  const dependentFields = allFields.reduce((acc, curr) => {
    // Simple check on cycle
    if (acc.length > allFields.length) {
      console.warn('getDependentFieldsChain cycle error!');

      return acc;
    }

    if (curr.dependsOnId === parentField.id) {
      acc.push(...getDependentFieldsChain(curr, allFields));
    }

    return acc;
  }, [] as IProductSpecificationFieldReference[]);

  return [parentField, ...dependentFields];
}
